import AccountType from '../model/account';
import AxiosInstance from '../api/http-config';

const ACCOUNT_LIST_PATH = '/accounts';

export let fetchAccounts = async (): Promise<AccountType[] | null> => {
  try {
    return AxiosInstance.get(ACCOUNT_LIST_PATH, {
      baseURL: 'http://localhost:4000'
    }).then(response => {
      return response.data.accounts;
    });
  } catch (err) {
    console.log(err);
    return null;
  }
};
